import { CreateOrEditBuiltInPackageRepositoryTriggerPage } from "./CreateOrEditBuiltInPackageRepositoryTriggerPage";
interface CreateBuiltInPackageRepositoryTriggerPageProps {
    spaceId: string;
    projectSlug: string;
}
export function CreateBuiltInPackageRepositoryTriggerPage({ spaceId, projectSlug }: CreateBuiltInPackageRepositoryTriggerPageProps) {
    return <CreateOrEditBuiltInPackageRepositoryTriggerPage create={true} spaceId={spaceId} projectSlug={projectSlug}/>;
}
